const addOpacityToHex = require('../addOpacityToHex');

const rgbToHexValue = (rgbValue) => {
    const value = rgbValue.toString(16);
    return value.length === 1 ? `0${value}`: value;
};

const convertRgbaToHex = ({ r, g, b, a = 1 }) => {
    const hex = `#${rgbToHexValue(r)}${rgbToHexValue(g)}${rgbToHexValue(b)}`;

    return addOpacityToHex(hex, a);
};

module.exports = convertRgbaToHex;
